import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PostHooks from "../../../Api/PostHooks";
import AlertComponent from "../../../Components/AlertComponent";
import FormNumberInput from "../../../Components/FormNumberInput";

const UserSavingsForm = ({ user, onClose, onSuccess }) => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [saveLoading, saveResponse, saveRequest] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSave = async (e) => {
    try {
      let formData = {
        entity_id: user.id,
        wallet_type: "savings",
        amount: e.amount,
      };

      const saveResp = await saveRequest({
        url: "/save",
        body: formData,
      });

      if (
        saveResp &&
        saveResp.status === 200 &&
        saveResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Save successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          saveResp?.data?.StatusMessage ??
          saveResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSave)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="amount"
          control={control}
          label={`Amount`}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>

      {/* <FormControl
        fullWidth
        error={!!errors.amount}
        sx={{
          mt: "5px",
        }}
      >
        <InputLabel htmlFor="amount">Amount</InputLabel>
        <OutlinedInput
          id="amount"
          type="number"
          {...register("amount", { required: true })}
          label="Amount"
          inputProps={{ step: "any" }}
        />
        {errors.amount && (
          <FormHelperText>Please enter an amount!</FormHelperText>
        )}
      </FormControl> */}

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="text" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={saveLoading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default UserSavingsForm;
